import React from 'react';
import FaIcon from './FaIcon';
import urlHelper from '../Helpers/urlHelper';

class RedirectLinkComponent extends React.Component {

    static defaultProps =
        {
            path: "",
            tooltipText: "",
            text: "",
            keyValuePairs: [],
            iconName: "fa-solid fa-arrow-up-right-from-square",
            isFigmaStyle: false,
        };

    constructor(props) {
        super(props);
        this.state = {
            commentList: [],
            loading: true,
            showAddNewComment: false,
            newComment: "",
        };
    }

    getUrl() {
        let url = urlHelper.generateRedirectUrlWithMultipleParameters(this.props.path, this.props.keyValuePairs);

        return url;
    }

    render() {
        if (this.props.isFigmaStyle)
            return (
                <a
                    className="secondarylink"
                    href={this.getUrl()}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-toggle="tooltip" data-placement="top" title="Open up in a new tab"
                >
                    {this.props.text}
                </a>
            )
        return (
            <a href={this.getUrl()} target="_blank" rel="noopener noreferrer">{
                <FaIcon
                    iconName={this.props.iconName}
                    tooltipText={this.props.tooltipText}
                    text={this.props.text}
                />
            }</a>
        );
    }
}


export default RedirectLinkComponent;
